import * as React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { Grid, Stack, useTheme } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import { ThemeModeToggle } from 'src/layouts/dashboard/header/ThemeModeToggle';

import Copyright from 'src/components/copyright/CopyRight';
import LanguagePopover from 'src/components/LanguagePopover';

import Carousel from './carousel/carousel';
import Logo from '../../components/logo/Logo';
import {
  carouselStyles,
  childrenStyles,
  containerStyles,
  topContainerStyles,
  boxContainerStyles,
} from './styles';

export function LoginLayout({ children }) {
  const { isSmallScreen } = useResponsiveScreen();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Grid container>
      {/* Left Column: Form Section */}
      <Grid item xs={12} md={6} bgcolor="background.default">
        <Box sx={{ ...boxContainerStyles, height: isSmallScreen ? 'auto' : '100vh' }}>
          <Box sx={topContainerStyles}>
            <Logo
              sx={{ width: isSmallScreen ? '120px' : '180px', height: '60px', mb: 1 }}
            />
            {/* Theme Toggle placed right next to the Language Selector */}
            <Stack direction="row" alignItems="center" spacing={1}>
              <ThemeModeToggle />
              <LanguagePopover />
            </Stack>
          </Box>
          <Box sx={containerStyles}>
            <Box sx={childrenStyles}>{children}</Box>
            {!isSmallScreen && (
              <>
                <br />
                <Copyright />
              </>
            )}
          </Box>
        </Box>
      </Grid>

      {/* Right Column: Carousel Section */}
      <Grid
        item
        xs={12}
        md={6}
        bgcolor={isDark ? 'background.neutral' : 'background.paper'}
      >
        <Box
          sx={{
            ...carouselStyles,
            height: isSmallScreen ? 'auto' : '100vh',
            mt: isSmallScreen && 3,
          }}
        >
          <Carousel />
        </Box>

        {isSmallScreen && (
          <>
            <Copyright />
            <br />
          </>
        )}
      </Grid>
    </Grid>
  );
}

LoginLayout.propTypes = {
  children: PropTypes.node,
};
